import './SelectionBar.style.less'
import { Button, Switch, Tooltip } from 'antd'
// import { BlockOutlined, PlusOutlined } from '@ant-design/icons'
import { PlusOutlined } from '@ant-design/icons'

interface Props {
  selectedCount: number
  isValid: boolean
  tooltipText: string | null
  canSeeNewInspection: boolean
  showSelectedOnly?: boolean
  onToggleShowSelected?: (val: boolean) => void
  onClearAll: () => void
  onCreateInspection: () => void
  // onMassUpdate: () => void TODO : Add Mass Update functionality for SelectionBar if needed
}

function SelectionBar({
  selectedCount,
  isValid,
  tooltipText,
  canSeeNewInspection,
  showSelectedOnly = false,
  onToggleShowSelected,
  onClearAll,
  onCreateInspection,
  // onMassUpdate, TODO : Add Mass Update functionality for SelectionBar if needed
}: Props) {
  if (selectedCount === 0 && !showSelectedOnly) return null

  const renderCreateInspectionBtn = () => {
    if (!canSeeNewInspection) return null

    if (selectedCount === 0) {
      return (
        <Button
          id="btn-new-inspection-disabled"
          size="large"
          icon={<PlusOutlined />}
          className="new-inspection-btn new-inspection-btn--muted"
          disabled
        >
          New Inspection
        </Button>
      )
    }

    if (isValid) {
      return (
        <Button
          id="btn-new-inspection"
          size="large"
          icon={<PlusOutlined />}
          className="new-inspection-btn"
          onClick={onCreateInspection}
        >
          New Inspection
        </Button>
      )
    }

    return (
      <Tooltip title={tooltipText} placement="bottom">
        <Button
          id="btn-new-inspection-muted"
          size="large"
          icon={<PlusOutlined />}
          className="new-inspection-btn new-inspection-btn--muted"
          onClick={onCreateInspection}
        >
          New Inspection
        </Button>
      </Tooltip>
    )
  }

  return (
    <div className="selection-bar">
      <div className="selection-bar__left">
        <span className="selection-bar__count">
          {selectedCount} order{selectedCount !== 1 ? 's' : ''} selected
        </span>
        <Button
          type="link"
          size="small"
          className="selection-bar__clear"
          onClick={onClearAll}
          disabled={selectedCount === 0}
        >
          Clear all
        </Button>
        <div className="selection-bar__toggle">
          <Switch
            size="small"
            checked={showSelectedOnly}
            onChange={onToggleShowSelected}
          />
          <span className="selection-bar__toggle-label">Show selected only</span>
        </div>
      </div>
      <div className="selection-bar__right">
        {/* <Button TODO : Add Mass Update functionality for SelectionBar if needed
          size="large"
          icon={<BlockOutlined />}
          onClick={onMassUpdate}
          disabled={selectedCount === 0}
          className="selection-bar__mass-update"
        >
          Mass Update
        </Button> */}
        {renderCreateInspectionBtn()}
      </div>
    </div>
  )
}

export default SelectionBar
